import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"
import DataNotFound from '@/components/data-not-found/DataNotFound';
import useGetApiReq from '@/hooks/useGetApiReq';
import ReactPaginate from 'react-paginate';
import Spinner from '@/components/spinner/Spinner';
import AdminWrapper from '@/admin/components/addmin-wrapper/AdminWrapper';
import ServiceRequestComp from '@/admin/components/service-request-comp/ServiceRequestComp';

const Requests = () => {
    const { res, fetchData, isLoading } = useGetApiReq();

    const params = useParams();

    const [requests, setRequests] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [page, setPage] = useState(1);

    const limit = import.meta.env.VITE_LIMIT;

    const getClientDetail = async () => {
        fetchData(`/admin/get-client-details/${params?.clientId}?page=${page}&limit=${limit}`);
    };

    useEffect(() => {
        getClientDetail();
    }, [page]);

    useEffect(() => {
        if (res?.status === 200 || res?.status === 201) {
            console.log("client details", res?.data);
            setRequests(res?.data?.clientInfo?.requests);
            const count = Math.ceil(res?.data?.clientInfo.reqCount / limit)
            setPageCount(count);
        }
    }, [res]);


    return (
        <AdminWrapper>
            <div>
                <div className="section-heading-container">
                    <h1 className='section-heading'>Requests</h1>
                </div>
                <Table className="mt-4">
                    <TableHeader className="bg-[#E5E7EB]">
                        <TableRow className="text-lg">
                            <TableHead>Service Name</TableHead>
                            <TableHead>Service Cost</TableHead>
                            <TableHead>Status</TableHead>
                            <TableHead>Date</TableHead>
                            <TableHead>Actions</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {requests?.map((request) => (
                            <ServiceRequestComp
                                key={request._id}
                                serviceRequest={request}
                                getServiceRequests={getClientDetail}
                            />
                        ))}
                    </TableBody>
                </Table>

                {requests.length === 0 && isLoading &&
                    <Spinner size={30} />
                }

                {requests.length === 0 && !isLoading &&
                    <DataNotFound name={"Requests"} />
                }


                {pageCount > 0 &&
                    <div className="mt-10 mb-5">
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            pageCount={pageCount}
                            onPageChange={(e) => setPage(e.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </div>}
            </div>
        </AdminWrapper>
    )
}

export default Requests